import { api } from "./api";

export interface TenantDetailData {
  TenantDetailId: number;
  TenantId: number;
  PhoneNumber: string;
  Email: string;
  Website: string;
  Twitter: string;
  Instagram: string;
  OwnerName: string;
  OwnerPhoneNumber: string;
  OwnerEmail: string;
  StoreManagerName: string;
  StoreManagerPhoneNumber: string;
  StoreManagerEmail: string;
  MarketingName: string;
  MarketingPhoneNumber: string;
  MarketingEmail: string;
  MaxCapacity: number;
  IsActive: boolean;
  Status: number;
}

export interface GetTenantDetailResponse {
  Code: number;
  Message: string;
  TotalRecord: number;
  tenantDetailDatas: TenantDetailData[];
}

export const GetTenantDetail = async (
  tenantdetailid: number,
  tenantid: number,
  number: number,
  page: number
): Promise<GetTenantDetailResponse | undefined> => {
  try {
    const url = `/tenant/v1/gettenantdetail?tenantdetailid=${tenantdetailid}&tenantid=${tenantid}&number=${number}&page=${page}`;
    const response = await api.get(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};

export interface SaveTenantDetailRequest {
  tenantDetailData: TenantDetailData;
}

export interface SaveTenantDetailResponse {
  Code: number;
  Message: string;
}

export const SaveTenantDetail = async (
  tenantDetailData: TenantDetailData
): Promise<SaveTenantDetailResponse | undefined> => {
  try {
    const url = `/tenant/v1/savetenantdetail`;
    const response = await api.post(url, { tenantDetailData });
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};

export interface BrandDetailData {
  TenantId: number;
  BrandId: number;
  BrandName: string;
  MallId: number;
  MallName: string;
  Floor: string;
  Unit: string;
  Area: number;
  BrandCategoryId: number;
  BrandCategoryName: string;
  BrandMainCategoryId: number;
  MainCategory: string;
  CapacityLabel: string;
  Status: number;
  brandData: null | unknown;
}

export interface GetBrandResponse {
  brandDetailDatas: BrandDetailData[];
  TotalRecord: number;
  Code: number;
  Message: string;
}

export const GetBrand = async (
  brandid: number,
  tenantid: number,
  number: number,
  page: number
): Promise<GetBrandResponse | undefined> => {
  try {
    const url = `/brand/v1/getbrand?brandid=${brandid}&tenantid=${tenantid}&number=${number}&page=${page}`;
    const response = await api.get(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};

export interface BrandDropdownItem {
  DataId: number;
  DataLabel: string;
}

export interface GetBrandDropdownResponse {
  Code: number;
  Message: string;
  data: BrandDropdownItem[];
}

export const GetBrandDropdown = async (
  referenceid: number
): Promise<GetBrandDropdownResponse | undefined> => {
  try {
    const url = `/dropdown/v1/getbrand?referenceid=${referenceid}`;
    const response = await api.get(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};